const getCode = (origin: TSFixMe, destination: TSFixMe): TSFixMe => {
  return `${origin.code}-${destination.code}`
}

export const resolvers = {
  Segment: {
    duration(segment: TSFixMe) {
      if (segment.companyLineSpecs.length > 0) {
        const lineSpec = segment.companyLineSpecs[0]

        return lineSpec.duration
      }

      return null
    },
    distance(segment: TSFixMe) {
      if (segment.companyLineSpecs.length > 0) {
        const lineSpec = segment.companyLineSpecs[0]

        return lineSpec.distance
      }

      return null
    },
    hasAllPrices(segment: TSFixMe) {
      let hasAllPrices = true
      let index = 0

      while (hasAllPrices && index < segment.companyLineSpecs.length) {
        const lineSpec = segment.companyLineSpecs[index]
        hasAllPrices = lineSpec.fares.length > 0
        index++
      }

      return hasAllPrices
    },
    code(segment: TSFixMe) {
      return getCode(segment.origin, segment.destination)
    }
  },
  SeasonEventSegment: {
    code(segment: TSFixMe) {
      return getCode(segment.origin, segment.destination)
    }
  },
  ConstraintSegment: {
    code(segment: TSFixMe) {
      return getCode(segment.origin, segment.destination)
    }
  }
}
